import React, { useState } from "react"

export interface UseFormProps {

}

export interface UseFormReturn<I extends UseFormProps> {
    elementos:I;
    reset:any;
    setNewAttVal:any;
    updateAttVal:any;
    
    handleChangeEvent:any;
    handleClickEvent:any;

    updateAttDate:any;
}

/**
 * Hook para el manejo de formularios.
 * @param initialFormState
 * @returns 
 */
export const useForm = <I extends UseFormProps>( initialFormState:I ):UseFormReturn<I> => {

    const [ formState, setFormState ] = useState( initialFormState );
    const [ resetFormState, setResetFormState ] = useState( formState );
    
    /**
     * Reset del formulario.
     */
    const reset = () => {
        //setFormState( initialFormState );
        setFormState( initialFormState );
    }

    /**
     * Agrega un nuevo atributo al formulario.
     * @param name 
     * @param value 
     */
    const setNewAttVal = (name:string, value:string) => {
        setFormState({
                ...formState,
                [ name ] : value
            });
        setResetFormState({
                ...resetFormState,
                [ name ] : value
            });
    }

    /**
     * Actualiza un atributo del formulario
     * @param name
     * @param value 
     */
    const updateAttVal = (name:string, value:string) => {
        setFormState({
                ...formState,
                [ name ] : value
            });
    }

    /**
     * Actualiza el valor del campo.
     * @param changeEvent 
     */
    const handleChangeEvent = ( changeEvent:React.ChangeEvent<HTMLInputElement | HTMLSelectElement> ) => {
        const target = changeEvent.target;
        if ( target.type === 'checkbox' || target.type === 'radio' ) {
            console.error('Usar handleClickEvent.');
        } else {
            //console.log(target.name, target.value)
            setFormState(
                {
                    ...formState,
                    [ target.name ] : target.value.trim()
                }
            );
        }
        //console.log(formState)
    }

    /**
     * Actualiza el valor del campo.
     * @param clickEvent 
     */
    const handleClickEvent = (clickEvent:React.MouseEvent<HTMLInputElement>) => {
        const target = clickEvent.currentTarget;
        if ( target.type === 'checkbox' || target.type === 'radio' ) {
            //console.log(target.name, target.checked, target.value)
            setFormState(
                {
                    ...formState,
                    [ target.name ] : target.checked ? target.value : ''
                }
            )
        } else {
            console.error('Usar handleChangeEvent.');
        }
    }

    

    /**
     * Actualiza un atributo Date del formulario
     * @param name
     * @param value 
     */
    const updateAttDate = (name:string, value:Date) => {
        //console.log(name, value)
        setFormState({
                ...formState,
                [ name ] : value
            });
    }

    return { elementos:formState, reset, setNewAttVal, updateAttVal, handleChangeEvent, handleClickEvent, updateAttDate};
}